import { ViolationService } from '../../../violations-sets/violation-service/violation.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DriversService } from '../../../drivers/drivers-service/drivers-service';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import * as moment from 'moment';
import * as _ from 'underscore';
import { takeUntil } from 'rxjs/operators';
import { sweetAlert } from 'src/app/utils/swal';
import { ServiceAreasService } from '../../../service-areas/service-areas-service/service-areas.service';
import { AssigTripsService } from '../../assigntrips-service/assigntrips-service';
@Component({
  selector: 'app-planner-schedule-logs-modal',
  templateUrl: './planner-schedule-logs-modal.component.html',
  styleUrls: ['./planner-schedule-logs-modal.component.css']
})
export class PlannerScheduleLogsModalComponent implements OnInit {
  user: any;
  timeZone;
  driverTrips=[];
  @Input() preData;
  @Output() closeModal = new EventEmitter();
  selectedDriverId =''
  selectedTable ='driverWise'
  driversReasons = [];

  constructor(
    private driverService: DriversService,
    private violationService: ViolationService,
    private sharedDataService: SharedDataService,
    private serviceArea: ServiceAreasService,
    private assignTripService: AssigTripsService,

  ) { }

  ngOnInit() {
    this.getUser();
    console.log("Data check",this.preData);
    this.driversReasons = this.flat(this.preData);
    console.log("Drivers Reasons", this.driversReasons);
  }

  flat(data: any) {
    const flattened = [];

    for (const driverId in data) {
      const group = data[driverId];
      let isHeaderSet = false;

      for (const reason of group.reasons) { 
        flattened.push({
          driver: {...group.driver},
          ...reason,
          isShowHeader: !isHeaderSet ? true : false
        });

        if (!isHeaderSet) {
          isHeaderSet = true;
        }
      }
    }
    return flattened;
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(user => {
        if (user) {
          this.user = user;
          this.timeZone = this.user.timeZone;

        }
      });
  }


  closeScheduleLogsModal(){
    this.closeModal.emit()
  }

  selectedDriverTrips(key) {
    if(key){

      this.driverTrips = this.preData[key].reasons;

    }else{
      this.driverTrips = [];
    }
  }

  sortMethod(a, b) {
    return a.value.driver.displayName - b.value.driver.displayName
  }

  setTable(tab) {
    this.selectedTable = tab;
  }

  trackByFn(index, item) {
    // if (!item) return;
    return index; // index or item.id
  }

  ngOnDestroy(): void{

  }

}
